import { render } from "./SellersPage.vue?vue&type=template&id=ebb00b5a&ts=true"
import script from "./SellersPage.vue?vue&type=script&lang=ts"
export * from "./SellersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__